const API_URL = process.env.REACT_APP_API_URL;
export const APP_V2 = process.env.REACT_APP_V2;

export default API_URL;
